import { apiCall, API_CONFIG, DEFAULT_PRODUCTS_PAYLOAD } from './api';
import { buildPublicFileUrl, downloadPublicFile } from '../utils/downloadHelpers';

export const seoAPI = {
  fetchSeoProducts: async ({
    page = 1,
    limit = 50,
    searchQuery = '',
    filterStatus = 'all',
    filterCategory = 'all',
    filterSubCategory = 'all',
    filterImage = 'all',
    seoScoreFilter = 'all',
    productId = 0,
  } = {}) => {
    const payload = {
      ...DEFAULT_PRODUCTS_PAYLOAD,
      page,
      limit,
      searchQuery: searchQuery.trim(),
      category: filterCategory !== 'all' ? filterCategory : '',
      subCategory: filterSubCategory === 'all' ? '' : filterSubCategory,
      productId,
      isAvailable: filterStatus === 'all' ? '' : filterStatus === 'instock' ? 'yes' : 'no',
      imageFilter: filterImage,
      seoScoreFilter,
    };

    return await apiCall(API_CONFIG.ENDPOINTS.SEO_LIST, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  fetchSeoProduct: async (productId, _id) => {
    const query = _id ? `?_id=${encodeURIComponent(_id)}` : '';
    return await apiCall(
      `${API_CONFIG.ENDPOINTS.SEO_PRODUCT}/${productId}${query}`,
      { method: 'GET' }
    );
  },

  saveSeo: async (payload) => {
    return await apiCall(API_CONFIG.ENDPOINTS.SEO_SAVE, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  },

  fetchSeoCategories: async ({
    page = 1,
    limit = 50,
    searchQuery = '',
    seoScoreFilter = 'all',
    typeFilter = 'all',
  } = {}) => {
    return await apiCall(API_CONFIG.ENDPOINTS.SEO_CATEGORY_LIST, {
      method: 'POST',
      body: JSON.stringify({
        page,
        limit,
        searchQuery: searchQuery.trim(),
        seoScoreFilter,
        typeFilter,
      }),
    });
  },

  fetchSeoCategory: async (categoryId, subCategoryId = null) => {
    const query = subCategoryId ? `?subCategoryId=${encodeURIComponent(subCategoryId)}` : '';
    return await apiCall(
      `${API_CONFIG.ENDPOINTS.SEO_CATEGORY}/${categoryId}${query}`,
      { method: 'GET' }
    );
  },

  saveCategorySeo: async (payload) => {
    return await apiCall(API_CONFIG.ENDPOINTS.SEO_CATEGORY_SAVE, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  },

  createSitemap: async () => {
    const response = await apiCall(API_CONFIG.ENDPOINTS.SEO_SITEMAP, {
      method: 'GET',
    });

    if (!response.success) {
      return response;
    }

    const fileName = response.data?.fileName || 'sitemap.xml';
    const publicUrl = response.data?.publicUrl
      || (typeof response.data === 'string' ? response.data : buildPublicFileUrl('/sitemap.xml'));
    const downloadUrl = buildPublicFileUrl('/sitemap.xml');

    try {
      await downloadPublicFile('/sitemap.xml', fileName);
      return {
        ...response,
        data: {
          ...(typeof response.data === 'object' ? response.data : {}),
          publicUrl,
          downloadUrl,
          fileName,
        },
        downloaded: true,
      };
    } catch (downloadError) {
      console.error('Sitemap download error:', downloadError);
      return {
        ...response,
        data: {
          ...(typeof response.data === 'object' ? response.data : {}),
          publicUrl,
          downloadUrl,
          fileName,
        },
        downloaded: false,
        downloadError: downloadError.message,
      };
    }
  },
};
